<template>
  <div class="achievement-box">
    <div class="title">
      <h1>业绩分配</h1>
      <div class="btns" v-if="contractsDetails.isArchive !== 'Y'">
        <h2
          @click="achievementClick('新增')"
          style="margin-right: 10px"
          v-hasPermi="['system:achievementsAllotRecord:add']"
          v-if="contractsDetails.auditStatus === '3'"
        >
          <a-icon style="margin-right: 10px" type="edit" />业绩人
        </h2>
        <h2
          type="primary"
          v-hasPermi="['system:achievementsAllotRecord:Achievements']"
          @click="getDistributionFn"
          v-if="contractsDetails.auditStatus === '3'"
        >
          {{ isDistribution ? '确认分配' : '编辑' }}
        </h2>
      </div>
    </div>
    <div class="achievement-user">
      <div class="achievement-item" v-for="(item, index) in achievementList" :key="index">
        <div class="item-left">
          <img v-if="item.avatar" :src="item.avatar" alt="" />
          <a-avatar v-else :size="64" icon="user" :src="imgUrlpor" />
          <div>
            <h1>{{ item.deptName }}.{{ item.employeeName }}</h1>
            <p>{{ item.contractRole | filterDict(achievementTypeList) }}</p>
          </div>
          <div>
            <a-tag color="green"> {{ item.resourceType === '2' ? '客源' : '房源' }} </a-tag>
          </div>
        </div>
        <div class="item-right">
          <div>
            <template v-if="item.performanceType == 1">
              <h1 style="width: 80px">{{ item.achievementsRatio ? item.achievementsRatio+'%' : '' }}</h1>
            </template>
            <template v-else>
              <h1 style="width: 80px">固定值</h1>
            </template>
            <p v-if="item.achievementsType=='2'">{{ item.achievementsMoney ? '-'+item.achievementsMoney : '' }}</p>
            <p v-else>{{ item.achievementsMoney ? item.achievementsMoney : '' }}</p>
            <!-- 价格 -->
          </div>
          <div class="edit-btn">
            <div v-show="isDistribution">
              <a-button
                shape="circle"
                v-hasPermi="['system:achievementsAllotRecord:edit']"
                @click="achievementClick(item)"
              >
                <a-icon type="edit" theme="filled" />
              </a-button>
              <a-popconfirm
                placement="bottomRight"
                ok-text="确定"
                cancel-text="取消"
                buttonWidth="100"
                @confirm="getDeleteDeleteAchievement(item)"
              >
                <template slot="title">
                  <p>确定删除吗？</p>
                </template>
                <a-button shape="circle" v-hasPermi="['system:achievementsAllotRecord:remove']">
                  <a-icon type="delete" theme="filled" />
                </a-button>
              </a-popconfirm>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
    props: {
        contractsDetails: {
            type: Object,
            default: () => ({})
        },
        achievementList: {
            type: Array,
            default: () => []
        },
        achievementTypeList: {
            type: Array,
            default: () => []
        },
        commission: {
            type: Object,
            default: () => ({})
        },
        isDistribution: {
            type: Boolean,
            default: false
        }
    },
    data () {
        return {
            imgUrlpor: require('@/assets/home-imgs/头像.svg')
        }
    },
    methods: {
        achievementClick (item) {
            this.$emit('achievementClick', item)
        },
        getDistributionFn () {
            this.$emit('getDistributionFn')
        },
        getDeleteDeleteAchievement (item) {
            this.$emit('getDeleteDeleteAchievement', item)
        }
    }
}
</script>

<style lang="less" scoped>
.achievement-box {
      .title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        h1 {
          font-size: 16px;
          font-weight: 700;
          color: var(--ThemeColor);
        }
      }
      .btns {
        display: flex;
        i {
          color: var(--ThemeColor);
          font-size: 16px;
          margin-top: 2px;
        }
        h2 {
          font-weight: 700;
          font-size: 14px;
          color: var(--ThemeColor);
          padding: 0 10px;
          cursor: pointer;
        }
        h2:last-child {
          width: 80px;
        }
      }
      .achievement-user {
        margin-top: 30px;
        .achievement-item {
          display: flex;
          justify-content: space-between;
          height: 100px;
          .item-left {
            display: flex;
            img {
              width: 60px;
              height: 60px;
              border-radius: 50%;
            }
            div {
              padding-left: 20px;
              color: #222222;
              h1 {
                font-weight: 700;
                color: #222222;
                font-size: 14px;
              }
            }
          }
          .item-right {
            display: flex;
            align-items: center;
            width: 160px;
            .edit-btn {
              margin-left: 30px;
              margin-right: 30px;
              > div {
                display: flex;
                flex-direction: column;
                button {
                  margin: 6px 10px;
                  background-color: var(--ThemeColor);
                  color: #fff;
                  display: inline-block;
                }
              }
            }
          }
        }
      }
}
</style>
